import { Suspense, useEffect } from "react";
import { RouterProvider } from "react-router/dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LazyMotion, domAnimation } from "framer-motion";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider } from "@/lib/auth";
import { ToastProvider } from "@/components/ui/toast";
import { TooltipProvider } from "@/components/ui/tooltip";
import { HelmetProvider } from "react-helmet-async";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { CookieBanner } from "@/components/CookieBanner";
import { CurrencyDetectionBanner } from "@/components/CurrencyDetectionBanner";
import { preloadCriticalRoutes } from "@/components/PreloadLink";
import { router } from "@/router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useEffect(() => { preloadCriticalRoutes(); }, []);

  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen bg-[#0f0a1a]" />
      }
    >
      <ErrorBoundary>
        <LazyMotion features={domAnimation}>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider defaultTheme="dark">
              <AuthProvider>
                <ToastProvider>
                  <TooltipProvider>
                    <HelmetProvider>
                      <RouterProvider router={router} />
                    </HelmetProvider>
                    <CurrencyDetectionBanner />
                    <CookieBanner />
                  </TooltipProvider>
                </ToastProvider>
              </AuthProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </LazyMotion>
      </ErrorBoundary>
    </Suspense>
  );
}

export default App;
